import { environment } from '@environment'

/**
 * localStorage keys that must survive a logout / auth reset. These hold
 * device-level UX preferences (not session/auth data), so wiping them on logout
 * would wrongly re-trigger first-run experiences (e.g. coachmark tours) every
 * time the same user signs back in on this browser.
 *
 * NOTE: 'mh_coachmarks' must stay in sync with `CoachmarkService.STORAGE_KEY`.
 */
const PERSISTENT_STORAGE_KEYS = ['mh_coachmarks']

/**
 * Clears localStorage the way logout/auth-failure paths intend (drop all auth &
 * session data) while preserving device-level preferences in
 * {@link PERSISTENT_STORAGE_KEYS}. Use this instead of `localStorage.clear()`.
 */
export function clearAuthStorage(): void {
  try {
    const preserved = new Map<string, string>()
    for (const key of PERSISTENT_STORAGE_KEYS) {
      const value = localStorage.getItem(key)
      if (value !== null) preserved.set(key, value)
    }
    localStorage.clear()
    for (const [key, value] of preserved) localStorage.setItem(key, value)
  } catch (e) {
    console.error('Error clearing auth storage:', e)
  }
}

export function getDisableGeneralChatFromStorage(): boolean {
  try {
    const keys = Object.keys(localStorage)
    const auth0Key = keys.find(key => key.startsWith('@@auth0spajs@@') && key.endsWith('@@user@@'))
    if (auth0Key) {
      const auth0Data = localStorage.getItem(auth0Key)
      if (auth0Data) {
        const parsed = JSON.parse(auth0Data)
        return parsed?.decodedToken?.user?.[`${environment.localStorageKey}`]?.ui_permissions?.disableGeneralChat === true
      }
    }
  } catch (e) {
    console.error('Error reading disableGeneralChat from localStorage:', e)
  }
  return false
}
